module.exports = __webpack_public_path__ + "img/3_81.0d5cccfc.png";